import EnterRecoveryFreespins from "slotworks/state-machine/standard/states/enter-recovery-freespins";
import soundManager from "slotworks/sound/sound-manager";
import MessagesComponent from "components/messages/messages-component";
import Components from "slotworks/components/components";
import G288SpinReelTransition from "components/matrix/transitions/spin-reel-transition";
import slotDefinition from "slotworks/model/slot-definition";

export default class G288EnterRecoveryFreespins extends EnterRecoveryFreespins {

    public complete() {
        const reelTransition = Components.matrix.getTransition() as G288SpinReelTransition;
        const fsReelset = slotDefinition.reelsets.get("freespins");
        reelTransition.setReelset(fsReelset);
        soundManager.customEvent("freespins_music");
        (Components.footer as MessagesComponent).onEnterFreespins();
        super.complete();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/enter-recovery-freespins.ts